import { Table as AntdTable } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import {
  ITableColumnModel,
  TableFactoryRowModel,
  TableFactoryStoreParams,
} from 'stores/common';

import { ControllersCellFactory } from '../ControllersCellFactory';

import s from './SummaryRow.module.scss';

type SummaryRowProps = {
  summaryRow?: TableFactoryRowModel | null;
  columns: ITableColumnModel[];
  tableParams: TableFactoryStoreParams;
};

const SummaryRow: React.FC<SummaryRowProps> = ({
  summaryRow,
  columns,
  tableParams,
}) => {
  if (!summaryRow) {
    return null;
  }

  return (
    <AntdTable.Summary.Row>
      {columns.map((elem, index) => {
        return (
          <AntdTable.Summary.Cell
            index={index}
            key={elem.data.id}
            className={s.summary}
          >
            {summaryRow?.cells[elem.data.id] && (
              <ControllersCellFactory
                record={summaryRow?.cells[elem.data.id]}
                row={summaryRow}
                tableParams={tableParams}
              />
            )}
          </AntdTable.Summary.Cell>
        );
      })}
    </AntdTable.Summary.Row>
  );
};

export default observer(SummaryRow);
